import { Injectable } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { Observable, EMPTY } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { DashboardService } from '../dashboard/dashboard.service';
import { RegenerateQuestionDialogComponent } from '../components/regenerate-question-dialog/regenerate-question-dialog.component';

@Injectable({ providedIn: 'root' })
export class RegenerateFlowService {
    constructor(
        private dialog: MatDialog,
        private dashboardService: DashboardService,
    ) { }

    /**
     * Open-only: returns dialog close result so callers decide when to show loader and when to call API.
     */
    ask(appliesTo: 'MCQ' | 'OPEN_ENDED' | 'CODING', prefill: string[] = []) {
        const dialogRef = this.dialog.open(RegenerateQuestionDialogComponent, {
            disableClose: true,
            panelClass: 'regenerate-dialog',
            width: '680px',
            maxWidth: '95vw',
            data: { appliesTo, prefill }
        });
        return dialogRef.afterClosed();
    }

    /**
     * Opens the regenerate dialog and performs the regenerate POST.
     * Returns an Observable of the backend response when regeneration is executed,
     * or completes without emission if the dialog is cancelled.
     */
    launch(appliesTo: 'MCQ' | 'OPEN_ENDED' | 'CODING', questionId: string): Observable<any> {
        const dialogRef = this.dialog.open(RegenerateQuestionDialogComponent, {
            disableClose: true,
            panelClass: 'regenerate-dialog',
            width: '680px',
            maxWidth: '95vw',
            data: { appliesTo }
        });

        return dialogRef.afterClosed().pipe(
            switchMap((result: any) => {
                if (!result) return EMPTY;
                if (result === 'cancel') return EMPTY;
                const headers = { 'skip-loader': 'true' } as any;
                const additionalPrompts: string[] = (result?.additionalPrompts || []);
                return this.dashboardService.reGenerateQuestion(questionId, headers, additionalPrompts);
            })
        );
    }
}


